import { render } from "./EdicionCategoriaProductos.vue?vue&type=template&id=4c4ce706&scoped=true"
import script from "./EdicionCategoriaProductos.vue?vue&type=script&lang=js"
export * from "./EdicionCategoriaProductos.vue?vue&type=script&lang=js"

import "./EdicionCategoriaProductos.vue?vue&type=style&index=0&id=4c4ce706&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4ce706"]])

export default __exports__